

<mat-sidenav-container style="height: 100%">
  <mat-sidenav #sidenav
               mode="over"
               [style.width]="getSidenavWidth()"
               [disableClose]="true"
               style="background-color: #153a57; cursor: pointer; overflow: hidden"
               [ngStyle]="{ transition: 'width 0.3s ease-in-out' }"
               opened="true">
    <mat-nav-list style="padding-top: 65px"
                  (mouseenter)="interact()"
                  (mouseleave)="leave($event)">
      <div *ngIf="showProjectsContainer"
           class="project-container"
           [ngClass]="{'open': showProjectsContainer, 'closed': !showProjectsContainer}"
           (scroll)="onScroll($event)">
        <mat-form-field>
          <input matInput [(ngModel)]="searchProjectName" placeholder="{{'search' | localize}}" />
        </mat-form-field>
        <div class="project-item"
             (click)="onSelectedProject(item.id)"
             *ngFor="let item of filterProject()"
             [ngClass]="{'highlighted-project': item.id === selectedProjectId}">
          {{ item.projectName }}
        </div>
        <!--<button *ngIf="authControl('AddProject')" [ngClass]="_appsService.classes" class="add-project-button">
      <mat-icon style="color:white; font-size:x-large">add</mat-icon>
      {{'newProject' | localize}}
    </button>-->
      </div>
      <mat-list-item [ngClass]="{'center-content': sidenavWidth <= 6, 'expanded-sidenav': sidenavWidth > 6}"
                     [ngStyle]="{'background-color': sidenavWidth > 6 ? '#153A57' : '#204D71', 'border-bottom':'1px solid #497DA6'}"
                     routerLinkActive="active"
                     [disableRipple]="true"
                     (click)="displayProjects()">

        <!-- 🔹 Collapsed mode: only image -->
        <ng-container *ngIf="sidenavWidth <= 6">
          <img [src]="'assets/icons/sidemenu/basarsoft-vector.png'" style="width:24px;" />
        </ng-container>

        <!-- 🔹 Expanded mode: image + text + dropdown -->
        <ng-container *ngIf="sidenavWidth > 6">
          <div style="display: flex; justify-content:space-between; background-color: #204D71 !important; border-radius: 20px; padding: 6px 14px; border: 1px solid #497DA6; align-items: center; width:290px;">
            <div style="display:flex;">
              <img [src]="'assets/icons/sidemenu/basarsoft-vector.png'" style="width:24px;" />

              <div class="sidenav-item">
                <p [matTooltip]="selectedProjectName"
                   style="margin-bottom:0; color:white; margin-left:10px; font-size:13px;"
                   [ngClass]="this._appsService.classes">
                  {{ selectedProjectName | truncate:truncateLimit }}
                </p>
              </div>
            </div>
            <mat-icon style="margin-left:30px;" [ngClass]="{'rotate-down': showProjectsContainer, 'rotate-right': !showProjectsContainer}">
              expand_more
            </mat-icon>
          </div>
        </ng-container>

      </mat-list-item>
      <ng-container *ngFor="let sideMenuItem of sideMenuList; let i = index">
        <mat-list-item [ngClass]="{'center-content' : sidenavWidth <= 6,'expanded-sidenav': sidenavWidth > 6}"
                       [attr.id]="sideMenuItem.tutorialId || ('tutorial-sidemenu-' + sideMenuItem.menuName)"
                       routerLinkActive="active"
                       [disableRipple]="true"
                       (click)="onSideMenuItemClick(i)"
                       [routerLink]="[sideMenuItem.path]">
          <img [src]="'assets/icons/sidemenu/' + sideMenuItem.icon + '.png'" style="width: 24px" />
          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
            <p style="margin-bottom: 0; color: white; margin-left: 10px; font-size:13px;">
              {{ sideMenuItem.menuName | localize }}

            </p>
          </div>
          <button mat-icon-button *ngIf="sideMenuItem.hasDrop && sidenavWidth > 6"
                  style="position: absolute; right: 0">
            <mat-icon [ngClass]="{
                'rotate-icon': true,
                'rotate-icon-open': sideMenuItem.dropState,
                'rotate-icon-close': !sideMenuItem.dropState
              }">
              {{ "expand_less" }}
            </mat-icon>

            <!--<mat-icon>{{ sideMenuItem.dropState ? 'expand_less' : 'expand_more' }}</mat-icon>-->
          </button>
        </mat-list-item>

        <ng-container>
          <div [ngClass]="{
              'submenu-container': true,
              open: sideMenuItem.dropState
            }">
            <ng-container *ngFor="let subMenuItem of sideMenuItem.subMenuItems">
              <mat-list-item *ngIf="subMenuItem.operation == 0"
                             style="width: 100%; display: flex; justify-content: flex-start"
                             [attr.id]="subMenuItem.tutorialId || null"
                             routerLinkActive="active"
                             [routerLink]="[subMenuItem.path]"
                             (click)="onSubMenuItemClick(subMenuItem)">
                <div style="
                    display: flex;
                    justify-content: center;
                    position: absolute;
                    top: 0;
                    left: 13%;
                    height: 100%;
                    align-items: center;
                  ">
                  <mat-icon style="margin-right: 6px"
                            *ngIf="subMenuItem.icon.length > 0"
                            mat-list-icon>
                    {{ subMenuItem.icon }}
                  </mat-icon>
                  <span style="color: white; font-size:13px;">
                    {{
                    subMenuItem?.menuName | localize
                    }}
                  </span>
                </div>
              </mat-list-item>
              <mat-list-item *ngIf="subMenuItem.operation == 1 && subMenuItem.type == 0"
                             style="width: 100%; display: flex; justify-content: flex-start"
                             [attr.id]="subMenuItem.tutorialId || null">
                <div style="
                    display: flex;
                    justify-content: center;
                    position: absolute;
                    top: 0;
                    left: 25%;
                    height: 100%;
                    width: 70%;
                    align-items: center;
                    background-color: #153a57;
                  ">
                  <mat-form-field style="width: 100%"
                                  appearance="fill"
                                  class="team-select custom-class">
                    <mat-select style="color: white"
                                placeholder="İş Formu"
                                [(ngModel)]="selectedWorkForm"
                                (selectionChange)="
                        onItemSelected(subMenuItem.type, $event)
                      ">
                      <mat-option *ngFor="let item of workForms"
                                  [value]="item">{{ item.templateName }}</mat-option>
                    </mat-select>
                    <mat-icon style="color: white">
                      {{ "expand_more" }}
                    </mat-icon>
                  </mat-form-field>
                </div>
              </mat-list-item>
              <mat-list-item *ngIf="subMenuItem.operation == 1 && subMenuItem.type == 12"
                             style="width: 100%; display: flex; justify-content: flex-start"
                             [attr.id]="subMenuItem.tutorialId || null">
                <div style="
                    display: flex;
                    justify-content: center;
                    position: absolute;
                    top: 0;
                    left: 25%;
                    height: 100%;
                    width: 70%;
                    align-items: center;
                    background-color: #153a57;
                  ">
                  <mat-form-field style="width: 100%"
                                  appearance="fill"
                                  class="team-select custom-class">
                    <mat-select style="color: white"
                                placeholder="Anket Formu"
                                [(ngModel)]="selectedDefaultForm"
                                (selectionChange)="
                        onItemSelected(subMenuItem.type, $event)
                      ">
                      <mat-option *ngFor="let item of defaultForms"
                                  [value]="item">{{ item.templateName }}</mat-option>
                    </mat-select>
                    <mat-icon style="color: white">
                      {{ "expand_more" }}
                    </mat-icon>
                  </mat-form-field>
                </div>
              </mat-list-item>
              <mat-list-item *ngIf="subMenuItem.operation == 2 && subMenuItem.type == 5"
                             style="width: 100%; display: flex; justify-content: flex-start"
                             [attr.id]="subMenuItem.tutorialId || null">
                <div style="width: 100%">
                  <button style="
                      width: 100%;
                      color: white;
                      font-size: 13px;
                      border-radius: 5px;
                    "
                          (click)="dynamicMapOperations(subMenuItem.type)"
                          mat-stroked-button
                          color="primary"
                          class="add-team-btn">
                    {{ subMenuItem.menuName }}
                    <mat-icon class="add-team-icon">add</mat-icon>
                  </button>
                </div>
              </mat-list-item>
              <mat-list-item *ngIf="subMenuItem.operation == 1 && subMenuItem.type == 9"
                             style="width: 100%; display: flex; justify-content: flex-start"
                             [attr.id]="subMenuItem.tutorialId || null">
                <div style="
                    display: flex;
                    justify-content: center;
                    position: absolute;
                    top: 0;
                    left: 25%;
                    height: 100%;
                    width: 70%;
                    align-items: center;
                    background-color: #153a57;
                  ">
                  <mat-form-field style="width: 100%"
                                  appearance="fill"
                                  class="team-select custom-class">
                    <mat-select style="color: white"
                                placeholder="Bölge Formu"
                                [(ngModel)]="selectedRegionForm"
                                (selectionChange)="
                        onItemSelected(subMenuItem.type, $event)
                      ">
                      <mat-option *ngFor="let item of regionForms"
                                  [value]="item">{{ item.templateName }}</mat-option>
                    </mat-select>
                    <mat-icon style="color: white">
                      {{ "expand_more" }}
                    </mat-icon>
                  </mat-form-field>
                </div>
              </mat-list-item>
              <mat-list-item *ngIf="subMenuItem.operation == 2 && subMenuItem.type == 9"
                             style="width: 100%; display: flex; justify-content: flex-start">
                <div style="width: 100%">
                  <button style="
                      width: 100%;
                      color: white;
                      font-size: 13px;
                      border-radius: 5px;
                    "
                          (click)="dynamicMapOperations(subMenuItem.type)"
                          mat-stroked-button
                          color="primary"
                          class="add-team-btn">
                    {{ subMenuItem.menuName }}
                    <mat-icon class="add-team-icon">add</mat-icon>
                  </button>
                </div>
              </mat-list-item>
            </ng-container>
          </div>
        </ng-container>

        <hr *ngIf="[0, 1, 4].includes(sideMenuItem.order)"
            style="margin-left: 14px; margin-right: 18px; border-color: #23547a" />
      </ng-container>
    </mat-nav-list>
  </mat-sidenav>

  <!--<div class="example-sidenav-content">-->
  <!-- <router-outlet></router-outlet> -->
  <!--<mat-icon (click)="sidenav.toggle()" class="sidenav-menu">menu</mat-icon>
  </div>-->
</mat-sidenav-container>
